import React, { useState } from 'react';
import ReportForm from './components/ReportForm';
import SuccessView from './components/SuccessView';

function App() {
  const [isSuccess, setIsSuccess] = useState(false);

  return (
    <div className="min-h-screen bg-brand-bg flex items-center justify-center p-4 font-sans selection:bg-brand-main/30">
      <div className="w-full max-w-[400px] bg-brand-card rounded-[14px] shadow-2xl shadow-black/50 p-6 sm:p-8">
        
        {/* Header */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-brand-bg mb-3 shadow-inner">
            <span className="text-2xl">📝</span>
          </div>
          <h1 className="text-xl font-bold text-white tracking-wide">
            Memogram 投稿申告
          </h1>
        </div>

        {/* Form or Success Content */}
        {isSuccess ? (
          <SuccessView onReset={() => setIsSuccess(false)} />
        ) : (
          <ReportForm onSuccess={() => setIsSuccess(true)} />
        )}

        {/* Footer */}
        <div className="mt-8 pt-6 border-t border-[#3A3A52]/50 text-xs text-gray-400 space-y-1.5 text-center">
          <p>※ 1日に何度でも申告できます</p>
          <p>※ ポイントは毎晩23:00に集計されます</p>
        </div>

      </div>
    </div>
  );
}

export default App;